import { Navigate, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './auth/AuthContext'
import { DropDetailPage } from './pages/DropDetailPage'
import { DropNewPage } from './pages/DropNewPage'
import { DropsPage } from './pages/DropsPage'
import { ForgotPasswordPage } from './pages/ForgotPasswordPage'
import { LoginPage } from './pages/LoginPage'
import { MfaRecoverPage } from './pages/MfaRecoverPage'
import { MfaSetupPage } from './pages/MfaSetupPage'
import { RecipientPage } from './pages/RecipientPage'
import { RegisterPage } from './pages/RegisterPage'
import { ResetPasswordPage } from './pages/ResetPasswordPage'
import { VerifyEmailPage } from './pages/VerifyEmailPage'

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/" element={<Navigate to="/drops" replace />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/mfa/setup" element={<MfaSetupPage />} />
        <Route path="/mfa/recover" element={<MfaRecoverPage />} />
        <Route path="/drops" element={<DropsPage />} />
        <Route path="/drops/new" element={<DropNewPage />} />
        <Route path="/drops/:dropId" element={<DropDetailPage />} />
        <Route path="/d/:dropId" element={<RecipientPage />} />
        <Route path="*" element={<Navigate to="/drops" replace />} />
      </Routes>
    </AuthProvider>
  )
}
